import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { saveAs } from "file-saver";
import { QRCodeCanvas } from "qrcode.react";
import QRCode from "qrcode";

const AddImagesInDqr = () => {
  const navigate = useNavigate();
  const { id, name } = useParams();
  const canvasRef = useRef(null);
  const imgRef = useRef(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [qrCodeValue, setQrCodeValue] = useState("");

  // State to hold form data
  const [formData, setFormData] = useState({
    name: "",
    ImageCatagory: "Select",
    images: null,
    center: false,
    center2: false,
    positionX: "",
    positionY: "",
    imageWidth: "",
    imageHeight: "",
    text: "",
    fontFamily: "Select",
    textSize: "",
    textPositionX: "",
    textPositionY: "",
    fontcolor: "",
    addqr: "",
  });

  // State to hold API response or error
  const [message, setMessage] = useState("");
  // State to control the visibility of the popup
  const [showPopup, setShowPopup] = useState(false);

  // Function to handle the popup close
  const handleClosePopup = () => {
    setShowPopup(false);
  };

  // Function to handle the popup open
  const handleOpenPopup = () => {
    setShowPopup(true);
  };

  const handleSubmit = async (e) => {};

  const handlePreview = async (e) => {
    e.preventDefault();

    if (!imageLoaded) {
      alert("Please wait for the image to load before previewing.");
      return;
    }

    setShowPopup(true); // This will trigger the useEffect which draws the canvas.
  };

  // Handle input change for text and file inputs separately
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      const file = files[0];
      setFormData((prevData) => ({
        ...prevData,
        [name]: file,
      }));

      if (file) {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          imgRef.current = img;
          setImageLoaded(true); // Set the image as loaded **only after** `imgRef` is updated.
          console.log("Image loaded successfully");
        };
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const drawCanvas = () => {
    setTimeout(() => {
      const canvas = canvasRef.current;
      if (canvas && imgRef.current && imageLoaded) {
        const ctx = canvas.getContext("2d");
        console.log("Drawing on canvas with loaded image");

        // Clear the canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Draw image on the canvas
        ctx.drawImage(imgRef.current, 0, 0, 320, 480);

        // Draw text on the canvas
        const textSize = parseInt(formData.textSize, 10);
        const fontFamily = formData.fontFamily;
        const textPositionX = parseFloat(formData.textPositionX);
        const textPositionY = parseFloat(formData.textPositionY);

        if (!isNaN(textSize) && fontFamily) {
          ctx.font = `${textSize}px ${fontFamily}`;
          ctx.fillStyle = formData.fontcolor || "black";
          ctx.fillText(formData.text, textPositionX, textPositionY);
        }

        // Draw QR Code if addqr is provided
        if (formData.addqr) {
          const qrCodeCanvas = document.createElement("canvas");
          qrCodeCanvas.width = parseFloat(formData.imageWidth) || 100;
          qrCodeCanvas.height = parseFloat(formData.imageHeight) || 100;

          // Generate the QR code
          QRCode.toCanvas(
            qrCodeCanvas,
            formData.addqr,
            { width: qrCodeCanvas.width },
            (error) => {
              if (error) {
                console.error(error);
                return;
              }
              // Draw the generated QR code onto the main canvas
              const qrCodePositionX = formData.positionX
                ? parseFloat(formData.positionX)
                : 0;
              const qrCodePositionY = formData.positionY
                ? parseFloat(formData.positionY)
                : 0;
              ctx.drawImage(
                qrCodeCanvas,
                qrCodePositionX,
                qrCodePositionY,
                qrCodeCanvas.width,
                qrCodeCanvas.height
              );
            }
          );
        }
      } else {
        console.error("Canvas or image not available for drawing");
      }
    }, 50); // Optional small delay to ensure all rendering is ready.
  };

  useEffect(() => {
    if (imageLoaded && canvasRef) {
      drawCanvas();
    }
  }, [imageLoaded, canvasRef, formData]);

  const downloadCanvasAsJPG = () => {
    const canvas = canvasRef.current;
    canvas.toBlob(
      (blob) => {
        saveAs(blob, "canvas-image.jpg");
      },
      "image/jpeg",
      1.0
    );
  };

  const [text, setText] = useState("");
  const [isBold, setIsBold] = useState(false);
  const [isItalic, setIsItalic] = useState(false);
  const [isUnderline, setIsUnderline] = useState(false);

  const getStyle = () => {
    let style = {};
    if (isBold) style.fontWeight = "bold";
    if (isItalic) style.fontStyle = "italic";
    if (isUnderline) style.textDecoration = "underline";
    return style;
  };

  const generateQRCode = () => {
    setQrCodeValue(formData.addqr);
  };

  useEffect(() => {
    if (showPopup && imageLoaded && canvasRef.current) {
      drawCanvas();
    }
  }, [showPopup, imageLoaded]);

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Add DQR Image</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Image</label>
                              <input
                                type="file"
                                className="form-control"
                                onChange={handleChange}
                                name="images"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Image Catagory</label>
                              <select
                                className="form-control"
                                name="ImageCatagory"
                                value={formData.ImageCatagory}
                                onChange={handleChange}
                              >
                                <option value="Select">Select</option>
                                <option value={true}>Welcome Image</option>
                                <option value={false}>QR Image</option>
                                <option>Success Image</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="name"
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Add Qr</label>
                              <input
                                type="url"
                                className="form-control"
                                onChange={handleChange}
                                name="addqr"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Image Width</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.imageWidth}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="imageWidth"
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Image Height</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.imageHeight}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="imageHeight"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>Center</label>
                              <input
                                type="checkbox"
                                className="form-control"
                                checked={formData.center}
                                onChange={handleChange}
                                name="center"
                              />
                            </div>
                          </div>

                          <div className="col-sm-5">
                            <div className="form-group">
                              <label>Image position - x</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.positionX}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="positionX"
                              />
                            </div>
                          </div>

                          <div className="col-sm-5">
                            <div className="form-group">
                              <label>Image position - y</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.positionY}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="positionY"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Example Text</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.text}
                                onChange={handleChange}
                                name="text"
                                placeholder="Enter ..."
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Font Family</label>
                              <select
                                className="form-control"
                                name="fontFamily"
                                value={formData.fontFamily}
                                onChange={handleChange}
                              >
                                <option value="Select">Select</option>
                                <option
                                  value="Arial"
                                  style={{ fontFamily: "Arial" }}
                                >
                                  Arial
                                </option>
                                <option
                                  value="Verdana"
                                  style={{ fontFamily: "Verdana" }}
                                >
                                  Verdana
                                </option>
                                <option
                                  value="Times New Roman"
                                  style={{ fontFamily: "Times New Roman" }}
                                >
                                  Times New Roman
                                </option>
                                <option
                                  value="Georgia"
                                  style={{ fontFamily: "Georgia" }}
                                >
                                  Georgia
                                </option>
                                <option
                                  value="Garamond"
                                  style={{ fontFamily: "Garamond" }}
                                >
                                  Garamond
                                </option>
                                <option
                                  value="Courier New"
                                  style={{ fontFamily: "Courier New" }}
                                >
                                  Courier New
                                </option>
                                <option
                                  value="Brush Script MT"
                                  style={{ fontFamily: "Brush Script MT" }}
                                >
                                  Brush Script MT
                                </option>
                              </select>
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Text Size</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.textSize}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="textSize"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Text position - x</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.textPositionX}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="textPositionX"
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Text position - y</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.textPositionY}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="textPositionY"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Font Color</label>
                              <input
                                type="color"
                                className="form-control"
                                value={formData.fontcolor}
                                onChange={handleChange}
                                name="fontcolor"
                                placeholder="Enter ..."
                              />
                            </div>
                          </div>
                          <div
                            className="buttons"
                            style={{
                              marginTop: "27px",
                              marginLeft: "10px",
                              height: "10px",
                            }}
                          >
                          </div>
                        </div>

                        <div className="card-footer">
                          <button type="submit" className="btn" style={{ backgroundColor: 'var(--info)', borderColor: 'var(--info)' }}>
                            Submit
                          </button>
                          <button
                            type="button"
                            className="btn btn-success ml-2"
                            onClick={handlePreview}
                            disabled={!imageLoaded} // Disable until the image is loaded
                          >
                            Preview
                          </button>

                          <button
                            type="button"
                            className="btn btn-secondary ml-2"
                            onClick={downloadCanvasAsJPG}
                          >
                            Download as JPG
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div>
                  <div style={getStyle()}>{text}</div>
                </div>
                <div></div>
              </div>
            </div>
          </section>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {showPopup && (
              <div
                className="popup"
                style={{
                  backgroundColor: "white",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  padding: "20px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                }}
              >
                <div className="popup-content">
                  <span
                    className="close"
                    onClick={handleClosePopup}
                    style={{
                      cursor: "pointer",
                      float: "right",
                      fontSize: "20px",
                    }}
                  >
                    &times;
                  </span>
                  <canvas ref={canvasRef} width="320" height="480"></canvas>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddImagesInDqr;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}